const initialState: any = {
  isLoading: false,
};

interface Action {
  type: string;
  payload?: any;
}

export function loading(state = initialState, action: Action): any {
  const { type, payload } = action;
  switch (type) {
    case 'LOADING SUCCESS':
      return {
        isLoading: payload,
      };

    default:
      return state;
  }
}